import { Box, Icon, MenuItem } from "@mui/material";
import CoreInput from "./CoreInput";
import CoreTypographyBody1 from "../dataDisplay/CoreTypographyBody1";
import React from "react";

export function CoreCustomPicker({ data, onPick, label, noLabel = false }) {
  const [search, setSearch] = React.useState("");

  return (
    <Box style={{ width: "100%", minWidth: "100%" }}>
      {!noLabel && (
        <CoreTypographyBody1>
          {"Choose from existing " + (label || "Project")}
        </CoreTypographyBody1>
      )}

      <CoreInput
        label={"Select " + (label || "Project")}
        endAdornment={<Icon>search</Icon>}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <Box
        style={{
          maxHeight: 200,
          minHeight: 200,
          overflowY: "auto",
          width: "100%",
        }}
      >
        {data
          .filter((row) =>
            search === "" || !search
              ? true
              : typeof row === "string"
                ? row.toLowerCase().includes(search.toLowerCase())
                : (row.label || row.name)
                    .toLowerCase()
                    .includes(search.toLowerCase()),
          )
          .map((row, i) => (
            <MenuItem
              key={"row-" + i}
              onClick={() => {
                onPick(row);
              }}
            >
              {typeof row === "string" ? row : row.label || row.name}
            </MenuItem>
          ))}
      </Box>
    </Box>
  );
}
